import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Team } from '../models/team';
import { map } from 'rxjs/operators';
import { ConfigService } from '../services/config.service';

interface LeagueTeamFilters {
  tournament_id?: number;
  tournament_season_id?: number;
  query?: string;
}

@Injectable({providedIn: 'root'})
export class LeagueTeamApi {
  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  async getLeagueTeams(filters?: LeagueTeamFilters): Promise<Team[]> {
    let params = new HttpParams();
    if (filters) {
      if (filters.tournament_id) {
        params = params.set('tournament_id', filters.tournament_id);
      }
      if (filters.tournament_season_id) {
        params = params.set('tournament_season_id', filters.tournament_season_id);
      }
      if (filters.query) {
        params = params.set('query', filters.query);
      }
    }
    return this.httpClient.get<any[]>(`${this.configService.get('apiUrl')}/api/v1/league_team/`, {params}).pipe(
      map(response => response.map(item => Team.toFront(item))),
    ).toPromise();
  }

  async getLeagueTeam(teamId: number): Promise<Team> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league_team/${teamId}/`).pipe(
      map(response => Team.toFront(response)),
    ).toPromise();
  }
}
